import React from "react";

const HeaderProfileSection = () => null;

export default HeaderProfileSection;
